import { Box, IconButton, Typography, Paper } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const CreatePassengerSelectAge = ({
  isReturn,
  ages,
  setAges,
  setReturnAges,
  passengers,
  setPassengers,
  returnPassengers,
  setReturnPassengers,
  sourcePassengers,
}) => {
  const handleIncrease = (age) => {
    if (!isReturn) {
      increase(age, setAges, setPassengers);
    } else {
      increase(age, setReturnAges, setReturnPassengers, sourcePassengers);
    }
  };

  const handleDecrease = (age) => {
    if (!isReturn) {
      decrease(age, passengers, setPassengers, setAges);
    } else {
      decrease(age, returnPassengers, setReturnPassengers, setReturnAges);
    }
  };

  const increase = (age, setAgesState, setPassengersState, sourcePassengersState = []) => {
    const ageKey = age === 1 ? "adult" : age === 2 ? "child" : "baby";

    setAgesState((prev) => ({ ...prev, [ageKey]: prev[ageKey] + 1 }));
    setPassengersState((prev) => {
      const sourcePassenger = sourcePassengersState[prev.length] || {};

      return [
        ...prev,
        {
          name: sourcePassenger.name || "",
          address: sourcePassenger.address || "",
          flight: sourcePassenger.flight || "",
          contactTel: sourcePassenger.contactTel || "",
          age,
        },
      ];
    });
  };

  const decrease = (age, passengersState, setPassengersState, setAgesState) => {
    const tmp = [...passengersState];
    const index = tmp.findLastIndex((x) => x.age === age);
    if (index !== -1) tmp.splice(index, 1);
    setPassengersState(tmp);
    const ageKey = age === 1 ? "adult" : age === 2 ? "child" : "baby";
    setAgesState((prev) => ({ ...prev, [ageKey]: prev[ageKey] - 1 }));
  };

  const passengerTypes = [
    { label: "Odrasli", range: "10+", age: 1, count: ages.adult },
    { label: "Deca", range: "2-10", age: 2, count: ages.child },
    { label: "Bebe", range: "0-2", age: 3, count: ages.baby },
  ];

  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: "#f9fafb",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" }, // kolona na mobilnom, red na desktopu
        justifyContent: "space-between",
        gap: 2,
        boxShadow: "none",
        borderRadius: 2,
      }}
      elevation={1}
    >
      {passengerTypes.map((p, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" }, // labela gore, dugmad ispod na telefonu
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            gap: { xs: 1, sm: 2 },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          {/* Labela */}
          <Box sx={{ textAlign: { xs: "left", sm: "center" } }}>
            <Typography fontWeight={600}>{p.label}</Typography>
            <Typography variant="body2" color="text.secondary">
              {p.range}
            </Typography>
          </Box>

          {/* Dugmad i broj */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mt: { xs: 1, sm: 0 }, // razmak ispod labela na telefonu
            }}
          >
            <IconButton
              onClick={() => handleDecrease(p.age)}
              disabled={p.count <= 0}
              sx={{
                backgroundColor: p.count > 0 ? "#6366f1" : "#d1d5db",
                color: "#fff",
                "&:hover": { backgroundColor: "#4f46e5" },
                width: 36,
                height: 36,
              }}
            >
              <RemoveIcon />
            </IconButton>

            <Typography
              sx={{
                minWidth: 32,
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              {p.count}
            </Typography>

            <IconButton
              onClick={() => handleIncrease(p.age)}
              sx={{
                backgroundColor: "#6366f1",
                color: "#fff",
                "&:hover": { backgroundColor: "#4f46e5" },
                width: 36,
                height: 36,
              }}
            >
              <AddIcon />
            </IconButton>
          </Box>
        </Box>
      ))}
    </Paper>
  );
};

export default CreatePassengerSelectAge;
